var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 376,
    viewBox: "0 0 358 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1124_33830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.612 362.151C284.965 362.151 307.949 339.101 307.949 310.666C307.949 282.232 284.965 259.181 256.612 259.181C228.259 259.181 205.274 282.232 205.274 310.666C205.274 339.101 228.259 362.151 256.612 362.151Z",
    stroke: "#36A367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.602 346.612C389.501 346.612 412.117 323.931 412.117 295.952C412.117 267.974 389.501 245.293 361.602 245.293C333.704 245.293 311.088 267.974 311.088 295.952C311.088 323.931 333.704 346.612 361.602 346.612Z",
    stroke: "#36A367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.61 418.707C301.177 418.707 326.768 393.043 326.768 361.385C326.768 329.726 301.177 304.062 269.61 304.062C238.042 304.062 212.452 329.726 212.452 361.385C212.452 393.043 238.042 418.707 269.61 418.707Z",
    stroke: "#36A367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.033 224.901C357.955 224.901 379.779 203.014 379.779 176.015C379.779 149.016 357.955 127.129 331.033 127.129C304.111 127.129 282.287 149.016 282.287 176.015C282.287 203.014 304.111 224.901 331.033 224.901Z",
    stroke: "#36A367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.616 292.282C400.21 292.282 424.201 268.222 424.201 238.542C424.201 208.863 400.21 184.803 370.616 184.803C341.022 184.803 317.031 208.863 317.031 238.542C317.031 268.222 341.022 292.282 370.616 292.282Z",
    stroke: "#36A367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.756 220.508C247.426 220.508 261.752 206.141 261.752 188.42C261.752 170.698 247.426 156.332 229.756 156.332C212.085 156.332 197.76 170.698 197.76 188.42C197.76 206.141 212.085 220.508 229.756 220.508Z",
    stroke: "#36A367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.818 367.106C338.074 367.106 354.495 350.638 354.495 330.324C354.495 310.01 338.074 293.542 317.818 293.542C297.562 293.542 281.141 310.01 281.141 330.324C281.141 350.638 297.562 367.106 317.818 367.106Z",
    stroke: "#36A367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.235 406.17C218.061 406.17 230.891 393.304 230.891 377.432C230.891 361.56 218.061 348.694 202.235 348.694C186.409 348.694 173.579 361.56 173.579 377.432C173.579 393.304 186.409 406.17 202.235 406.17Z",
    stroke: "#36A367",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1124_33830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 376,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore8);
export default __webpack_public_path__ + "static/media/explore8.2dc994b1e21493f45056bec352c25a96.svg";
export { ForwardRef as ReactComponent };